import React, { useState, useEffect, Fragment, useRef } from "react";
import { Menu, Dropdown, Tooltip, Modal } from 'antd';
import styles from "./scss/linklist.module.scss";
import { URInput } from "../../../shared/widgets/input";
import { useSelector } from "react-redux";
import {
   initialStateModel, chatwindowDetails, LoginState,
  rightSidePanelDetails
} from "../../../models/model";
import moment from "moment";
import { Cookie, getTimeFormat,getTooltipTime,urlify } from "../../../base/utils";
import _ from "lodash";
import ChatLike from "../chatWidgets/chatLike";
import store from "../../../context/store/store";
import { toastInformation } from "../../../base/callService/common";
import { SocketChatService } from "../../../base/socketChatService";
import { likeCommonFunction, saveChatCommonFunction } from "../../../base/socketChatService/utils";
import NoContent from "../../../shared/widgets/noContent";
import { URlinksSkeleton } from "../../../shared/skeletonLoading/linksSkeleton";
import NotFound from "../../../styles/images/empty_states/links_empty_state.svg";
import { config } from "../../../base/constant";
import { Types } from "../../../context/action/action";

type RightSidebarSte = {
  searchKey: string;
  deleteModelOpen: boolean;
  deletedData: any;
  tempLinkList:any;
  linkList:any;
  filterKey: string;
  AuthorList: any;
  isVisible:boolean;
  isSearch:any;
  searchText:string;
}

export default function LinksListsRight() {

  const rightSideLink: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  //const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);

  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const {chatWindowDetails}: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);

  const [getItem, setItem] = useState<RightSidebarSte>({
   searchKey:'', deleteModelOpen: false, deletedData:"",tempLinkList:[],linkList:[],filterKey: "All",AuthorList:[],isVisible:false,isSearch:[],searchText:""
  });
  const socketChat = useRef<any>(null);
  useEffect(()=>{
    
    let arr: any = [];
    if (chatWindowDetails?.team_id && !(_.isUndefined(chatWindowDetails?.teammembersdetails))) {
      arr = [...chatWindowDetails?.teammembersdetails]
    } else {
      arr = [userdetails, chatWindowDetails]
    }
    
    
  let linkFinalData: any = searchData(getItem.searchKey);
 
  let result: any = _(linkFinalData)
  .groupBy((o: any) => (o.timestamp &&
      moment(o.timestamp).format('DD MMM YYYY')))
  .map((contacts: any, letter: any) => ({ letter, contacts }))
    .value();
    setItem({ ...getItem, linkList: result,AuthorList: arr,tempLinkList: linkFinalData,isSearch:arr});

    Array.isArray(result) && result.map((contactsList:any, i:any)=> {

      let pr_fromuser = "";
      let pr_touser = "";
      Array.isArray(contactsList?.contacts) && contactsList?.contacts?.map((list:any, k:any)=> {
    
        if(pr_fromuser !== list?.from?.trim() || pr_touser !== list?.to?.trim()){
          result[i].contacts[k].isHeader = true;
        }else{
          result[i].contacts[k].isHeader = false;
        }
        pr_fromuser = list?.from?.trim();
        pr_touser = list?.to?.trim();
      })
      })

  },[rightSideLink.linkListDetails?.length])
  useEffect(() => {
    const userInfo:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if(userInfosess){
      const cookieData =JSON.parse(userInfosess);
      socketChat.current= new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
    if (chatWindowDetails && rightSideLink.linkListDetails?.length===0 ) {
      let fromUser = chatWindowDetails.chatId ? chatWindowDetails.chatId : chatWindowDetails.team_id;
      let linkListInput = {
        chatId: fromUser,
        offset: 10,
        orderType: 0,
        id: ""
      };
      socketChat.current.linkChatList(linkListInput);
    }
  }, []);



  const openLink = (url: any) => {
    if (!url.includes("http")) url = "https://" + url;
    window.open(url);
  };

  const searchnotesinList = (e: any) => {
    let response: any = searchData(e.target.value);
    let result: any = _(response)
    .groupBy((o: any) => (o.timestamp &&
        moment(o.timestamp).format('DD MMM YYYY')))
    .map((contacts: any, letter: any) => ({ letter, contacts }))
      .value();
    setItem({ ...getItem, searchKey: e.target.value,linkList: result });
  };


  const deleteChat = (data: any) => {
    socketChat.current.deleteForEveryone(data.id);
     let index:any = rightSideLink.linkListDetails.findIndex((e: any) => e.id === data.id);
     if (index !== -1) {
       rightSideLink.linkListDetails.splice(index, 1);
    }
     store.dispatch({
          type: Types.GET_LINK_LIST,
          payload: {
              isLink: true,
              linkListDetails: rightSideLink.linkListDetails
          }
      });
    toastInformation(config().DELETEMESSAGE, 'success');
    setItem({...getItem,deleteModelOpen:false});
  };
  const searchData = (str: string) => {
    let searchText = str.toLowerCase();
    return _.filter(rightSideLink.linkListDetails, function (data: any) {
      let linkName = data?.message?.messageType === "TEXT" ? (data?.message?.body.trim() || "") : "";;
      let sender = data?.fromDetails?.caller_id || '';
      let toTeam = (data?.toDetails?.caller_id ? data?.toDetails?.caller_id : data?.toDetails?.team_name) || '';
      let Datesearch = moment(new Date(parseInt(data?.timestamp))).format("ddd, MMM Do YYYY") || '';
      return (((linkName).toLowerCase()).includes(searchText) ||
        (sender).toLowerCase().includes(searchText) || (toTeam).toLowerCase().includes(searchText) ||
        (Datesearch.toString()).toLowerCase().includes(searchText));
    });
  };
  const copy = (data: any) => {
    let toast: string = ("Success! Link copied");
    navigator.clipboard.writeText(data.message.body);
    toastInformation(toast, "success");

  }
  const confirmDelete = (data:any) => {
    setItem({ ...getItem, deleteModelOpen: true,deletedData:data });
  };
  const closeSelection = () => {
    let deletedArray: any = [];

    store.dispatch({
      type: Types.SELECT_MESSAGE_ARRAY,
      payload: {
        selectMessageData: deletedArray
      }
    });

    setItem({ ...getItem, deleteModelOpen: false });
  };

    

    const openCalender = (key: any, list?: any) => {
        if (key === "calender") {
         // setnotesList({ ...notesList, isCalender: true, filterKey: "calender" });
        } else if (key === "All") {
          let result: any = _(getItem.tempLinkList)
          .groupBy((o: any) => (o.timestamp &&
              moment(o.timestamp).format('DD MMM YYYY')))
          .map((contacts: any, letter: any) => ({ letter, contacts }))
            .value();
          setItem({...getItem,linkList:result,filterKey: "All"  });
        } else {
          let date = new Date();
          let formatKey: any = key === "Today" ? moment(date).format('YYYY/MM/DD') : moment(date).subtract(1, 'day').format('YYYY/MM/DD');
          let response = _.filter(getItem.tempLinkList, ((data: any) => {
          let notesDate = moment(new Date(parseInt(data.timestamp))).format('YYYY/MM/DD');
            return notesDate === formatKey;
          }));
          let result: any = _(response)
            .groupBy((o: any) => (o.timestamp &&
                moment(o.timestamp).format('DD MMM YYYY')))
            .map((contacts: any, letter: any) => ({ letter, contacts }))
              .value();
           
          setItem({...getItem,linkList:result,filterKey: "All"  });
        }
      };

      const AuthorFilter = (list: any) => {
        const response: any = _.filter(getItem.tempLinkList, ((item) => {
          return item?.from === list?.sip_login_id.toString();
        }));
        let result: any = _(response)
            .groupBy((o: any) => (o.timestamp &&
                moment(o.timestamp).format('DD MMM YYYY')))
            .map((contacts: any, letter: any) => ({ letter, contacts }))
              .value();
           
          setItem({...getItem,linkList:result,filterKey: "All"  });
      };
      const handlescroll = (e: any) => {
        const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
        if (bottom && getItem.linkList.length > 0) {
          let fromUser = chatWindowDetails.chatId ? chatWindowDetails.chatId : chatWindowDetails.team_id;
           let linkListInput = {
            chatId: fromUser, offset: 20, orderType: 0, id: rightSideLink.linkListDetails?.length > 0
              ? rightSideLink.linkListDetails[rightSideLink.linkListDetails?.length - 1]?.id : ""
          };
          socketChat.current.linkChatList(linkListInput); 
        }
      }
      const handleChange = (flag:boolean)=>{
        setItem({ ...getItem,isVisible: flag});
      }
      const searchMember = (e: any) => {
        let searchText = e.target.value.toLowerCase();
        let response= _.filter(getItem.isSearch,((list:any)=>{
          let caller_id = list?.caller_id||"";
          return ((caller_id?.toLowerCase()).includes(searchText) );
        }));
        setItem({ ...getItem, AuthorList: response,searchText:searchText });
      };
  const menu = (
    <Menu className="rightdropactions2" >
      <Menu.Item>
        <div className={`notesdd ${styles.dropsdowns}`} >
          <div className={`searchnotes ${styles.innerlayerssearch}`}>
            <URInput placeHolder="Search" className="leftbarsearch notes" onChange={(e: any) => searchMember(e)}/>
          </div>
          <div className="innerlayers scroller">
           {getItem?.searchText === "" && <><h4>Date Created</h4>
            <ul className="datacreate">
            <li  key={'All'} onClick={() => openCalender("All")}>All</li>
              <li key={'Today'} onClick={() => openCalender("Today")}>Today</li>
              <li key={'Yesterday'} onClick={() => openCalender("Yesterday")}>Yesterday</li>
              {/* <li key={'calender'} onClick={() => openCalender("calender")}>Calender</li> */}

            </ul>
            <h4>Author</h4></>} 
            <ul>
            {getItem?.AuthorList?.map((man:any)=>{
                           return(
                             <>
                               <li onClick={()=>AuthorFilter(man)}>{man?.caller_id}</li>
                             </>
                            
                           );
                            
                         })
                      }
            </ul>

          </div>
        </div>

      </Menu.Item>


    </Menu>
  );
  return (
    <>

      <div className={styles.linksmain}>
        <div className={styles.rightbartop}>
          <div className={styles.linksnewbtn}>
          <span className={styles.titleText}>Links</span>
            {/*<URButton className="rightnewtask" name="Save Chat" />*/}
          </div>
          {(rightSideLink.isLink && rightSideLink.linkListDetails.length !== 0) ?
            <div className={styles.linkssearchbar}>
              <div className={styles.lefts}>
                <URInput placeHolder="Search" className="rightbarsearch" onChange={(e: any) => searchnotesinList(e)} />
              </div>
              <div>
              <Dropdown
               className="popss2"
                overlay={menu}
                trigger={['click']}
                visible={getItem.isVisible}
                onVisibleChange={handleChange}
                placement="bottomRight">
                {/* <p>All<span className={`icon_down-arrow menudroprotate`}></span></p> */}
                <div className={`${styles.rights}`} onClick={e => e.preventDefault()}>
              All <span
                        className={`icon_down-arrow menudroprotate`}></span>
          </div>
              </Dropdown>
              </div>
            </div> : <> </>}
        </div>
        {!rightSideLink.isLink ?
          [1, 2,3,4, 5, 6].map((data: any) => (
            <div className={styles.skeletonSec} key={data}>
              <URlinksSkeleton key={data} />
            </div>
          )) :
          (getItem.linkList && getItem.linkList.length === 0) &&
          <NoContent image={NotFound}
            title={"Worktual Links"}
            description={<>All your personal links reside here. Easily reference and check back at any time.</>} />}
              <div className={`scroller ${styles.rightbarbottom}`} onScroll={handlescroll}>
          {getItem.linkList && Array.isArray(getItem.linkList) && getItem.linkList.map((contactsDetails: any, index: any) => {
              return(   
                <Fragment key={index}>
          {Array.isArray(contactsDetails.contacts) && contactsDetails.contacts && contactsDetails.contacts.length > 0 ?
            contactsDetails.contacts.map((linkdata: any, i: any) => {
              let isBookmark: any = linkdata?.message?.isSave || [];
              //let saved: any = Object.keys(isBookmark);
              let LikeObeject: any = linkdata?.message?.liked || [];
              let isLike = (LikeObeject && LikeObeject['s' + userdetails.sip_login_id]) || 0;
              let savedBookmark = (isBookmark && isBookmark['s' + userdetails.sip_login_id]) || 0;
              let currentDate = getTooltipTime(linkdata?.timestamp);
              let from:any = linkdata?.fromDetails?.caller_id?.length <= 15 ? linkdata?.fromDetails?.caller_id : linkdata?.fromDetails?.caller_id?.substring(0, 15) + "...";
              let to:any = linkdata?.toDetails?.team_id ? linkdata?.toDetails?.team_name : linkdata?.toDetails?.caller_id ;
              return (<>
                <Fragment key={i}>
                {linkdata?.message?.messageType !== "FILE"  && <div className={styles.linkslist}>
                    {/* <div className={styles.toplayer}> */}
                      {/* <URAvatarGroup className='lefts size32'
                        profileInfo={
                          <>{linkdata.fromDetails?.profile_url ?  
                            <img src={linkdata.fromDetails?.profile_url} alt="" /> :
                            linkdata.fromDetails?.ImageURL ? 
                            <img src={linkdata.fromDetails?.profile_url} alt="" /> :

                              <span>{linkdata.fromDetails.caller_id.charAt(0)}</span>}         
                              <URStatusDot
                                className={userStatusColor(userdetails?.user_status, 'small')} />                
                          </>}
                      /> */}
                      {/* <h3><HighlightInner content={userdetails?.caller_id
                        === linkdata.fromDetails.caller_id ? "You" : linkdata.fromDetails.caller_id}
                  searchedData={getItem.searchKey}/>

                      <span className="icon_strokearrowright"></span>

                      <b><HighlightInner content={userdetails?.caller_id
                          === linkdata.toDetails?.caller_id ? "You" : linkdata.toDetails?.caller_id ?  linkdata.toDetails?.caller_id : linkdata.toDetails?.team_name ?  linkdata.toDetails?.team_name :"" }
                          searchedData={getItem.searchKey}/></b>
                    
      
                      <span className={styles.dates}>
                      {moment(linkdata?.timestamp).format("D MMM")}</span>
                        </h3> */}
                      {/* <h3>{userdetails?.caller_id === linkdata?.fromDetails?.caller_id
                        ? "You" : linkdata?.fromDetails?.caller_id !== undefined? from :'Unknown User'}
                        <span className="icon_strokearrowright"></span>

                        <b>{userdetails?.caller_id === linkdata?.toDetails?.caller_id ?
                          "You" : 
                          to <= 15
                              ? to :
                              to?.substring(0, 15) + "..." }</b>
                        <span className={styles.dates}>
                          {moment(linkdata?.timestamp).format("D MMM")}</span>
                      </h3>
                    </div> */}

                    <div className={styles.topbottomlayer}>
                      {/* <div className={styles.lefts}>

                        {savedBookmark === 1 ? <span className="icon_ribbon"><br /></span> :
                          <span className="icon_linkrotate"> <br /></span>}
                        <Tooltip mouseEnterDelay={0.5} placement="top" title={currentDate} >
                          <span className={styles.timeHover}>
                            {moment(linkdata?.timestamp).format('hh:mm')}
                          </span>
                        </Tooltip>
                      </div> */}
                      <div className={styles.hoverdiv}>
                        <ul>
                          <li onClick={() => copy(linkdata)}>
                            <Tooltip mouseEnterDelay={0.5} placement="top" title="Clip board">
                              <span className="icon_copydoc"></span></Tooltip></li>
                          <li onClick={() => likeCommonFunction(isLike === 0 ? 1 : 0, linkdata)} >
                            <Tooltip mouseEnterDelay={0.5} placement="top"
                              title={isLike === 0 ? 'Like' : 'Unlike'}>
                              <span className="icon_Like"></span></Tooltip></li>

                          <li onClick={() => saveChatCommonFunction(savedBookmark === 0 ? 1 : 0, linkdata)}>
                            <Tooltip mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ? 'Save Chat' : 'UnSave chat'}>
                              <span className={savedBookmark === 0 ?"icon_ribbon" :"icon_savechatsill"}></span></Tooltip></li>
                          {linkdata?.fromDetails?.sip_login_id === userdetails.sip_login_id &&
                          <li onClick={() => confirmDelete(linkdata)}><Tooltip  mouseEnterDelay={0.5} placement="top" title="Delete" >
                            <span className="icon_delete"></span></Tooltip></li> }
                        </ul>
                      </div>
                      {linkdata?.message?.messageType === "IMAGE" && linkdata?.message?.isLink === true ?
                      <p onClick={() => openLink(linkdata?.message?.body && linkdata?.message?.body?.text)} dangerouslySetInnerHTML={{ __html: urlify(linkdata?.message?.body?.text) }} >
                        </p>: 
                      <p onClick={() => openLink(linkdata?.message?.body && linkdata?.message?.body)} dangerouslySetInnerHTML={{ __html: urlify(linkdata?.message?.body) }}>
                        </p>}
                    </div>
                    <div className={styles.likeIcon}>
                      <ChatLike className='likeLeft likeSaved'
                        tooltipTitle={linkdata} message={linkdata}
                      /></div>
                  </div> }

                </Fragment>
              </>
              );
            }) : null}
                  </Fragment>
 )
})}
        </div>

      </div>
      <Modal title="Delete selected Link"
        centered
        visible={getItem.deleteModelOpen}
        onOk={() => deleteChat(getItem.deletedData)}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected Link?
      </Modal>

    </>
  );
};

